// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1HA8X","right":"styles_right__32-k1"};